import React from 'react';
import { getAppraisalPromotionsBackground } from 'site-modules/appraisal/utils/appraisal-promotions';
import PropTypes from 'prop-types';

import './appraisal-promotions-background.scss';

/**
 * @param {Object} props - Component properties
 * @param {string} props.promoValue - The promo value from URL query parameters
 */

export const AppraisalPromotionsBackground = ({ promoValue }) => {
  const { DESKTOP, MOBILE } = getAppraisalPromotionsBackground(promoValue);

  return (
    <>
      <div className="appraisal-promotions-background pos-a w-100">
        <div className="wrapper pos-r d-inline-block w-100">
          <picture>
            <source media="(min-width: 768px)" srcSet={DESKTOP} />
            <img src={MOBILE} alt="" />
          </picture>
        </div>
      </div>
    </>
  );
};

AppraisalPromotionsBackground.propTypes = {
  promoValue: PropTypes.string.isRequired,
};
